import { Component, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { TableService } from '../../services/integrated/table.service';
import { CartService } from '../../services/apicart/cart.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Globals } from '../../globals';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';
import { Router } from '@angular/router';
@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {
    private cols = [
        { field: 'images', show: true },
        { field: 'id', show: false },
        { title: 'fcart.lblproduct', field: 'name', show: true, filter: true },
        { title: 'fcart.price', field: 'price', show: true, filter: true },
        { title: 'number', field: 'amount', show: true, filter: true },
        { field: 'action', show: true },
    ];
    public type = "password";
    private id: number;
    public hiden: boolean;
    modalRef: BsModalRef;
    public amount: number;
    public item: any;
    public datacart = [];
    public lengthdatacart: number;
    public data: any;
    public alert = { skip: false, message: '' }
    fm: FormGroup;
    fmLogin: FormGroup;
    fmSingnup: FormGroup;
    public cwstable = new TableService();
    public connect;
    public token: any = {
        addcart: "api/addcart"
    }
    constructor(
        public router: Router,
        public toastr: ToastsManager,
        vcr: ViewContainerRef,
        private modalService: BsModalService,
        public cart: CartService, public fb: FormBuilder,
        public globals: Globals
    ) {
        this.toastr.setRootViewContainerRef(vcr);
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "addcart":
                    let type = (res['status'] == 1) ? "success" : (res['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](res['message'], type);
                    if (res['status'] == 1) {
                        this.cart.clear();
                        setTimeout(() => {
                            this.router.navigate(['/']);
                        }, 2000);
                    }
                    break;
                default:
                    break;
            }
        })
    }

    ngOnInit() {
        this.getlist();
        this.item = this.globals.CUSTOMER.get(true);
        this.fm = this.fb.group({
            name: [this.item.name, [Validators.required]],
            phone: [this.item.phone, [Validators.required]],
            address: [this.item.address, [Validators.required]],
            note: ''
        });
        //this.amount = (+isNaN(this.amount) || this.amount==0) ? item.amount :this.amount;
        this.hiden = true;
    }
    submit() {
        let data = { cart: this.getDataCart(), cartdetail: this.getItemDetail(), item: this.getitem() };
        this.globals.send({ path: this.token.addcart, token: "addcart", data: data });
    }
    getitem() {
        let res = {
            email: this.item.email ? this.item.email : '',
            name: this.item.name ? this.item.name : '',
            data: this.cart.get(),
        }
        return res;
    }
    getDataCart() {
        let cart = {
            code: (new Date()).valueOf(),
            day_start: new Date(),
            customer_id: this.item.id,
            delivery_address: this.datacart['address'],
            price_total: this.cart.total(),
            phone: this.datacart['phone'],
            amount_total: this.cart.amount(),
            note: this.datacart['note'],
            status: 1,
        }
        return cart;
    }
    getItemDetail() {
        return Object.values(this.cart.get().reduce((n, o, i) => {
            n[i] = {
                cart_id: 0,
                product_id: +o.id,
                amount: o.amount,
                price: o.price,
                total: (isNaN(+o.amount) ? 0 : +o.amount) * (isNaN(+o.price) ? 0 : +o.price),
                status: 1,
                note: (o.note) ? o.note : ''
            };
            return n;
        }, {}));
    }
    dataCart() {
        this.datacart = this.fm.value;
        if (!this.fm.valid) {
            this.alert.skip = true;
            this.alert.message = 'Bạn chưa nhập đầy dủ thông tin giao hàng. Vui lòng kiểm tra lại.'
            return false;
        } else {
            this.alert.skip = false;
            this.alert.message = '';
            this.lengthdatacart = (Array(this.datacart)).length
            return true;
        }
    }
    openModal(template: TemplateRef<any>, id: number) {
        this.id = id;
        this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
    }
    onClose() {
        this.modalRef.hide();
    }
    getlist() {
        this.cwstable._ini({ cols: this.cols, data: this.cart.get() });
    }
    addcart(amount, id) {
        let data = this.cart.reduce();
        if (data[id]) {
            data[id].amount = +amount;
        }
        this.cart.edit(data[id], id);
    }
    delCArt(id: number) {
        this.cart.remove(id);
        this.getlist();
        setTimeout(() => {
            this.onClose();
        }, 1000);
    }


}



// WEBPACK FOOTER //
// ./src/app/frontend/cart/cart.component.ts